import { z } from 'zod';

import { BatchStatistics } from '@e-origin/shared';

const countSchema = z.number().int().nonnegative().optional();
const idsSchema = z.array(z.coerce.string()).optional();

export const AdminBatchStatisticsSchema: z.ZodType<BatchStatistics> = z
  .object({
    total: countSchema,
    accepted: countSchema,
    acceptedIds: idsSchema,
    released: countSchema,
    releasedIds: idsSchema,
    rejected: countSchema,
    rejectedIds: idsSchema,
    notReleased: countSchema,
    notReleasedIds: idsSchema,
    inControl: countSchema,
    inControlIds: idsSchema,
    invalidated: countSchema,
    invalidatedIds: idsSchema,
    sent: countSchema,
    sentIds: idsSchema,
    analysisWrongValue: countSchema,
    analysisWrongDescription: countSchema,
    analysisWrongDescriptionFixed: countSchema,
    analysisWrongHsCode: countSchema,
    analysisWrongHsCodeFixed: countSchema,
  })
  .passthrough();
